import contractNameForm from "form/modal/contractName";
import { FORM_EDIT_CONTRACT_NAME } from "../constants";

export const ContractNameForm = contractNameForm.createInPageContainer(FORM_EDIT_CONTRACT_NAME);
